export function getError(error, emptyBasketError) {
  if (error === 'Empty basket') {
    return emptyBasketError
  } else {
    return error
  }
}
